document.addEventListener("DOMContentLoaded", () => {
  console.log("🟢 Vertex AI Search (Dark Premium Sidebar)");

  window.getVisitorId = function () {
    let id = localStorage.getItem("vertex_visitor_id");
    if (!id) {
      id = crypto.randomUUID();
      localStorage.setItem("vertex_visitor_id", id);
    }
    return id;
  };

  window.getAttributionToken = function () {
    try {
      const stored = localStorage.getItem("vertex_search_context");
      if (stored) {
        const context = JSON.parse(stored);
        // 24 hour TTL (86400000 ms)
        if (Date.now() - context.timestamp < 86400000) {
          return context.attributionToken;
        } else {
          localStorage.removeItem("vertex_search_context");
        }
      }
    } catch (e) { }
    return null;
  };

  window.setAttributionToken = function (token, query) {
    if (!token) return;
    localStorage.setItem("vertex_search_context", JSON.stringify({
      attributionToken: token,
      query: query,
      timestamp: Date.now()
    }));
  };

  window.trackVertexEvent = async function (eventType, payload) {
    try {
      const visitorId = window.getVisitorId();
      const eventPayload = {
        event_type: eventType,
        visitor_id: visitorId,
        tenant: window.shopkeeperTenant || "rugtown",
        ...payload
      };
      const baseUrl = window.BACKEND_BASE_URL || window.location.origin;
      await fetch(`${baseUrl}/api/events`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Visitor-ID': visitorId },
        body: JSON.stringify(eventPayload)
      });
    } catch (e) {
      console.error("Vertex Search: Failed to track event", e);
    }
  };

  // Auto-fire PDP detail-page-view
  if (window.location.pathname.startsWith('/products/')) {
    // Shopify usually exposes meta.product.id
    setTimeout(() => {
      const pid = (window.meta && window.meta.product && window.meta.product.id)
        || document.querySelector('[data-product-id]')?.getAttribute('data-product-id');
      if (pid) {
        const urlParams = new URLSearchParams(window.location.search);
        const vtoken = urlParams.get('vtoken') || window.getAttributionToken();

        window.trackVertexEvent("detail_page_view", {
          product_ids: [pid.toString()],
          attribution_token: vtoken
        });
      }
    }, 1000);
  }

  // ==========================================
  // Intercept Shopify Add To Cart (AJAX)
  // ==========================================
  const handleCartSuccess = async (response, isFetch) => {
    try {
      let data;
      if (isFetch) {
        data = await response.clone().json();
      } else {
        data = JSON.parse(response.responseText);
      }

      if (data && data.product_id) {
        const token = window.getAttributionToken();
        window.trackVertexEvent("add_to_cart", {
          product_ids: [String(data.product_id)],
          quantities: [data.quantity || 1],
          attribution_token: token
        });
      } else if (data && data.items) {
        // Cart Drawer/Multi-item add
        const token = window.getAttributionToken();
        const pids = data.items.map(i => String(i.product_id));
        const qty = data.items.map(i => i.quantity || 1);
        window.trackVertexEvent("add_to_cart", {
          product_ids: pids,
          quantities: qty,
          attribution_token: token
        });
      }
    } catch (e) {
      console.error("Vertex: Failed to parse cart add response", e);
    }
  };

  // Intercept fetch
  const originalFetch = window.fetch;
  window.fetch = async (...args) => {
    const response = await originalFetch(...args);
    const url = args[0]?.toString() || "";
    if (url.includes("/cart/add") && response.ok) {
      await handleCartSuccess(response, true);
    }
    return response;
  };

  // Intercept XMLHttpRequest
  const originalXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      if (this.responseURL && this.responseURL.includes("/cart/add") && this.status >= 200 && this.status < 300) {
        handleCartSuccess(this, false);
      }
    });
    return originalXHRSend.apply(this, arguments);
  };


  // Intersection Observer for Batched Impressions
  let visibleProductIds = new Set();
  let impressionDebounceTimer = null;
  let currentSearchQuery = "";

  const flushImpressions = () => {
    if (visibleProductIds.size === 0) return;
    const ids = Array.from(visibleProductIds);
    window.trackVertexEvent("impression", {
      product_ids: ids,
      search_query: currentSearchQuery
    });
    visibleProductIds.clear();
  };

  const impressionObserver = new IntersectionObserver((entries) => {
    let added = false;
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const pid = entry.target.getAttribute('data-product-id');
        if (pid) {
          visibleProductIds.add(pid);
          added = true;
          // Stop observing once recorded for impression
          impressionObserver.unobserve(entry.target);
        }
      }
    });
    if (added) {
      if (impressionDebounceTimer) clearTimeout(impressionDebounceTimer);
      impressionDebounceTimer = setTimeout(flushImpressions, 1000);
    }
  }, { threshold: 0.5 });

  window.handleVertexImageError = function (img, imagesBase64, handle = '', title = '') {
    try {
      const images = JSON.parse(atob(imagesBase64));
      const currentUrl = img.getAttribute('data-current-url') || img.src;

      let currentIndex = -1;
      for (let i = 0; i < images.length; i++) {
        const uri = images[i].url || images[i].uri || images[i].src;
        if (uri && (currentUrl.includes(uri) || uri.includes(currentUrl))) {
          currentIndex = i;
          break;
        }
      }

      // Layer 2: Retry with Proxy (wsrv.nl)
      if (!img.getAttribute('data-retried-proxy')) {
        console.log(`Vertex Search: Image failed, retrying with proxy: ${currentUrl}`);
        img.setAttribute('data-retried-proxy', 'true');
        const stripped = currentUrl.replace(/^https?:\/\//, "");
        img.src = `https://wsrv.nl/?url=${encodeURIComponent(stripped)}&w=600&output=webp&q=80`;
        return;
      }

      // Layer 3: Try next available image from Vertex data
      if (currentIndex !== -1 && currentIndex < images.length - 1) {
        const nextImage = images[currentIndex + 1];
        const nextUrl = nextImage.url || nextImage.uri || nextImage.src;
        console.log(`Vertex Search: Image failed after proxy retry, trying next (${currentIndex + 1}/${images.length}): ${nextUrl}`);
        img.setAttribute('data-current-url', nextUrl);
        img.removeAttribute('data-retried-proxy');

        let clean = nextUrl.toString().trim();
        if (clean.startsWith("//")) clean = "https:" + clean;
        if (clean.includes("cdn.shopify.com") && clean.includes("/products/")) {
          clean = clean.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)/g, "").replace(/\.(jpg|jpeg|png|gif|webp)/i, `_600x600.$1`);
        } else if (clean.includes("cdn.shopify.com") && clean.includes("/files/")) {
          clean = clean.replace(/_\d+x\d*(?=\.(jpg|jpeg|png|gif|webp))/i, "");
        } else if (clean.includes("owimages.com") || !clean.includes("rugtownplano")) {
          const stripped = clean.replace(/^https?:\/\//, "");
          clean = `https://wsrv.nl/?url=${encodeURIComponent(stripped)}&w=600&output=webp&q=80`;
        }
        img.src = clean;

        // SYNC WITH POTENTIAL VISUALIZER BUTTON (Future proofing)
        const rugCard = img.closest('.card') || img.closest('.card-wrapper');
        if (rugCard) {
          const btn = rugCard.querySelector('.see-in-room-btn');
          if (btn) {
            console.log(`Vertex Search: Syncing potential Visualizer button with next candidate: ${clean}`);
            btn.setAttribute('data-rug', clean.replace('&w=600', '&w=2048').replace('/card/', '/').replace('/thumb/', '/'));
          }
        }
        return;
      }

      // Layer 4: Active Discovery - Fetch freshest live image from Shopify database
      if (!img.getAttribute('data-retried-discovery')) {
        img.setAttribute('data-retried-discovery', 'true');
        const retryDiscovery = async () => {
          try {
            console.log(`Vertex Search: Layer 4 - Pinging Shopify for live image for product: ${handle || title}`);
            let freshUrl = '';

            // Try handle-based fetch first
            if (handle) {
              const res = await fetch(`/products/${handle}.js`);
              if (res.ok) {
                const product = await res.json();
                if (product.images && product.images.length > 0) freshUrl = product.images[0];
              }
            }

            // Fallback to title search if handle fails or isn't available
            if (!freshUrl && title) {
              const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(title)}&resources[type]=product`);
              if (res.ok) {
                const data = await res.json();
                const products = data.resources?.results?.products;
                if (products && products.length > 0) freshUrl = products[0].image;
              }
            }

            if (freshUrl) {
              console.log(`Vertex Search: Layer 4 Success - Found fresh URL: ${freshUrl}`);
              img.src = freshUrl;

              // SYNC WITH POTENTIAL VISUALIZER BUTTON
              const rugCard = img.closest('.card') || img.closest('.card-wrapper');
              if (rugCard) {
                const btn = rugCard.querySelector('.see-in-room-btn');
                if (btn) {
                  console.log(`Vertex Search: Syncing potential Visualizer button with discovery URL: ${freshUrl}`);
                  btn.setAttribute('data-rug', freshUrl);
                }
              }
              return;
            }
          } catch (e) {
            console.error("Discovery error:", e);
          }
          // Final failure state
          img.style.opacity = '0.3';
          img.onerror = null;
        };
        retryDiscovery();
        return;
      }

      // Final failure
      img.style.opacity = '0.3';
      img.onerror = null;
    } catch (e) {
      img.style.display = 'none';
    }
  };

  const initSearch = () => {
    const sort = document.getElementById("SortBy");
    if (sort) sort.onchange = null;

    let currentPage = 1;
    const ITEMS_PER_PAGE = 24;
    let totalItems = 0;
    let currentFacets = [];

    const performAiSearch = async (page = 1) => {
      let vertexRoot = document.getElementById("vertex-search-root");
      const shopifyGrid = document.getElementById("product-grid");

      if (!vertexRoot) {
        const templateSearch = document.querySelector(".template-search");
        if (!templateSearch) return;
        vertexRoot = document.createElement("div");
        vertexRoot.id = "vertex-search-root";
        vertexRoot.style.display = "none";
        templateSearch.appendChild(vertexRoot);
      }

      const params = new URLSearchParams(window.location.search);
      let hasBaseQuery = false;
      let baseParams = new URLSearchParams();
      if (vertexRoot && vertexRoot.hasAttribute("data-base-query")) {
        hasBaseQuery = true;
        baseParams = new URLSearchParams(vertexRoot.getAttribute("data-base-query"));
        for (const [key, value] of baseParams.entries()) {
          if (!params.has(key)) {
            params.append(key, value);
          }
        }
      }

      const query = params.get("q")?.trim() || "";
      const hasFilters = ['shape', 'color', 'size_bucket', 'style', 'material', 'pattern'].some(k => params.has(k));
      if (!query && !hasFilters && !hasBaseQuery) return;

      if (page === 1) {
        if (shopifyGrid) shopifyGrid.style.display = "none";
        vertexRoot.style.display = "block";
        if (!vertexRoot.querySelector('.vertex-skeleton')) {
          if (window.vertexPageContext && window.vertexPageContext.mode === 'browse') {
            vertexRoot.innerHTML = `
              <div class="vertex-skeleton" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 24px; padding: 20px 0;">
                ${Array(8).fill('<div style="background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.05); border-radius: 12px; aspect-ratio: 4/5; animation: vertexPulse 1.5s infinite;"></div>').join('')}
              </div>
              <style>
                @keyframes vertexPulse {
                  0% { opacity: 0.7; }
                  50% { opacity: 0.3; }
                  100% { opacity: 0.7; }
                }
              </style>
            `;
          } else {
            const searchTarget = query ? `"<strong>${query}</strong>"` : "filtered rugs";
            vertexRoot.innerHTML = `<p style="text-align:center;padding:60px 20px;color:#888;font-size:12px;letter-spacing:0.1em;text-transform:uppercase;">Searching for ${searchTarget}…</p>`;
          }
        }

        document.querySelectorAll(".template-search__results, .template-search__header p")
          .forEach(el => {
            if (el.textContent.includes("No results") || el.textContent.includes("results found for") || el.textContent.includes("Search results")) {
              el.style.display = "none";
            }
          });
      }

      try {
        const baseUrl = window.BACKEND_BASE_URL || window.location.origin;
        let queryStr = params.get('q') ? params.get('q').trim() : '';
        const isEmptySearch = window.location.pathname === '/search' && queryStr === '';
        let isBrowseMode = (window.vertexPageContext && window.vertexPageContext.mode === 'browse') || isEmptySearch;

        let fetchParams = new URLSearchParams(params.toString());

        // Intercept category-style queries and force them into Browse mode
        const BROWSE_INTERCEPTS = {
          'geometric rugs': 'geometric-rugs',
          'floral rugs': 'floral-rugs',
          'medallion rugs': 'medallion-rugs',
          'traditional rugs': 'traditional-rugs',
          'vintage rugs': 'vintage-rugs',
          'modern rugs': 'modern-rugs',
          'shag rugs': 'shag-rugs',
          'outdoor rugs': 'outdoor-rugs',
          'runners': 'runners',
          'persian rugs': 'persian-rugs',
          'moroccan rugs': 'moroccan-rugs',
          'boho rugs': 'boho-rugs'
        };

        let qLower = queryStr.toLowerCase();
        if (BROWSE_INTERCEPTS[qLower]) {
          isBrowseMode = true;
          fetchParams.delete('q');
          fetchParams.set('page_category', BROWSE_INTERCEPTS[qLower]);
        }

        let apiPath = isBrowseMode ? '/api/browse' : '/api/search';
        let fetchUrl = new URL(`${baseUrl}${apiPath}`);

        // Clean up empty 'q' parameter for browse requests to avoid sending q=+
        if (apiPath === '/api/browse' && fetchParams.has('q') && fetchParams.get('q').trim() === '') {
          fetchParams.delete('q');
        }

        fetchUrl.search = fetchParams.toString();
        fetchUrl.searchParams.set("page", page);
        fetchUrl.searchParams.set("page_size", ITEMS_PER_PAGE);
        fetchUrl.searchParams.set("tenant", window.shopkeeperTenant || "rugtown");

        let res = await fetch(fetchUrl.toString(), {
          headers: {
            'X-Visitor-ID': window.getVisitorId()
          }
        });
        if (!res.ok) throw new Error(`API error: ${res.status}`);

        let data = await res.json();

        // Track Search Event immediately
        currentSearchQuery = query;
        if (data.attribution_token) {
          window.vertexSearchContext = {
            attributionToken: data.attribution_token,
            query: query,
            timestamp: Date.now()
          };
          window.setAttributionToken(data.attribution_token, query);
          window.trackVertexEvent("search", {
            search_query: query,
            attribution_token: data.attribution_token
          });
        }

        const results = data.results || data.products || [];
        totalItems = data.totalSize || data.total_size || results.length;
        currentFacets = data.facets || [];
        currentPage = page;

        // ==========================================
        // Vertex Public Interception Event
        // Allows external UI rendering override
        // ==========================================
        const eventDetail = {
          results,
          data,
          page,
          query,
          totalItems,
          currentFacets,
          currentPage,
          params: Object.fromEntries(params.entries()),
          isBrowseMode,
          apiPath
        };

        // New canonical event
        const searchResultsEvent = new CustomEvent('vertex:search:results', {
          detail: eventDetail,
          cancelable: true
        });

        document.dispatchEvent(searchResultsEvent);

        // Backwards compatibility event
        const legacyEvent = new CustomEvent('vertex:api:data', {
          detail: eventDetail,
          cancelable: true
        });

        document.dispatchEvent(legacyEvent);

        // External UI took ownership
        if (
          searchResultsEvent.defaultPrevented ||
          legacyEvent.defaultPrevented
        ) {
          console.log('Vertex Search: External renderer intercepted API response.');
          return;
        }

        if (results.length === 0 && page === 1) {
          vertexRoot.innerHTML = `
            <div class="vertex-no-results" style="text-align:center; padding:100px 20px; color:#aaa;">
              <h2 style="color:#fff; text-transform:uppercase; letter-spacing:0.1em; font-size:20px; margin-bottom:15px;">No results found</h2>
              <p style="font-size:14px;">We couldn't find any rugs matching "<strong>${query}</strong>".</p>
              <p style="margin-top:20px;">
                <button onclick="window.location.href=window.location.pathname" style="background:#fff; color:#000; border:none; padding:12px 30px; font-weight:900; text-transform:uppercase; cursor:pointer; font-size:11px; letter-spacing:0.1em;">Clear Search</button>
              </p>
            </div>
          `;
          return;
        }

        const isRoundRequested = window.location.pathname.includes('round-rugs') || 
                                 query.toLowerCase().includes('round') || 
                                 params.getAll('shape').some(s => s.toLowerCase() === 'round');

        if (isRoundRequested && results.length > 0) {
          results.sort((a, b) => {
            const aHasRound = (a.images || []).some(img => { const u = (img.uri||img.url||img.src||"").toLowerCase(); return u.includes('_rnd') || u.includes('_round') || u.includes('-round') || u.includes('round_'); });
            const bHasRound = (b.images || []).some(img => { const u = (img.uri||img.url||img.src||"").toLowerCase(); return u.includes('_rnd') || u.includes('_round') || u.includes('-round') || u.includes('round_'); });
            return (bHasRound ? 1 : 0) - (aHasRound ? 1 : 0);
          });
        }

        renderPage(results, data);

        // ==========================================
        // Vertex Post-Render Lifecycle Event
        // Allows external scripts to augment UI (e.g. badges, quick view)
        // ==========================================
        document.dispatchEvent(
          new CustomEvent('vertex:ui:rendered', {
            detail: {
              results,
              data,
              page,
              query,
              totalItems,
              currentPage,
              params: Object.fromEntries(params.entries())
            }
          })
        );
      } catch (err) {
        console.error("Vertex search error:", err);
        if (page === 1) {
          if (shopifyGrid) shopifyGrid.style.display = "block";
          vertexRoot.style.display = "none";
        }
      }
    };

    window.changeSearchAiPage = function (dir) {
      const next = currentPage + dir;
      const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
      if (next >= 1 && next <= totalPages) {
        performAiSearch(next);
        window.scrollTo({ top: document.getElementById("vertex-search-root").offsetTop - 80, behavior: "smooth" });
      }
    };

    window.toggleVertexFilter = (key, value) => {
      const vertexRoot = document.getElementById("vertex-search-root");
      if (vertexRoot && vertexRoot.hasAttribute("data-base-query")) {
        const baseParams = new URLSearchParams(vertexRoot.getAttribute("data-base-query"));
        if (baseParams.has(key)) {
          console.warn(`Vertex Search: Cannot modify locked base filter category '${key}'`);
          return;
        }
      }

      const params = new URLSearchParams(window.location.search);
      const currentValues = params.getAll(key);
      if (currentValues.includes(value)) {
        const newValues = currentValues.filter(v => v !== value);
        params.delete(key);
        newValues.forEach(v => params.append(key, v));
      } else {
        params.append(key, value);
      }

      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.pushState({}, '', newUrl);
      performAiSearch(1);
    };

    window.toggleMobileFilters = () => {
      const sidebar = document.querySelector('.vertex-sidebar');
      if (sidebar) {
        sidebar.classList.toggle('active');
        document.body.style.overflow = sidebar.classList.contains('active') ? 'hidden' : '';
      }
    };

    function renderFilters(facets, isMobile = false) {
      if (!facets || facets.length === 0) return "";
      const params = new URLSearchParams(window.location.search);

      const vertexRoot = document.getElementById("vertex-search-root");
      let baseParams = new URLSearchParams();
      if (vertexRoot && vertexRoot.hasAttribute("data-base-query")) {
        baseParams = new URLSearchParams(vertexRoot.getAttribute("data-base-query"));
      }

      // RESTRICTION: Only show Shape, Color, Size, Style, Material
      const allowedKeys = ['shape', 'color', 'size_bucket', 'style', 'material'];
      const filteredFacets = facets.filter(f => allowedKeys.includes(f.key.replace("attributes.", "")));

      return `
        <div class="vertex-sidebar-filters" style="background: transparent; padding: 0; border: none;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 30px; border-bottom: 2px solid #fff; padding-bottom: 10px;">
            <h3 style="font-size: 14px; margin: 0; font-weight: 900; color: #fff; text-transform: uppercase; letter-spacing: 0.2em;">Filters</h3>
            <button class="vertex-mobile-close" onclick="toggleMobileFilters()" style="background:none; border:none; font-size: 32px; cursor:pointer; color:#fff; line-height:1;">&times;</button>
          </div>
          
          ${filteredFacets.map(facet => {
        const key = facet.key.replace("attributes.", "");
        let label = key.charAt(0).toUpperCase() + key.slice(1).replace("_", " ");
        if (key === "size_bucket") label = "Size";
        if (!facet.values || facet.values.length === 0) return "";

        const availableValues = facet.values.filter(fv => fv.count > 0);
        if (availableValues.length === 0) return "";

        return `
              <details open class="facet-accordion" style="margin-bottom: 25px; border-bottom: 1px solid #333; padding-bottom: 15px;">
                <summary style="list-style: none; display: flex; justify-content: space-between; align-items: center; cursor: pointer; font-weight: 800; font-size: 11px; color: #fff; text-transform: uppercase; letter-spacing: 0.15em;">
                  ${label}
                  <span class="accordion-icon" style="font-size: 10px; transition: transform 0.2s; opacity: 0.6;">⌄</span>
                </summary>
                <div class="facet-options" style="margin-top: 15px; display: flex; flex-direction: column; gap: 10px; max-height: 300px; overflow-y: auto; padding-right: 5px;">
                  ${availableValues.slice(0, 40).map(fv => {
          const isSelectedUrl = params.getAll(key).includes(fv.value);
          const isSelectedBase = baseParams.getAll(key).includes(fv.value);
          const isSelected = isSelectedUrl || isSelectedBase;

          const isKeyLocked = baseParams.has(key);
          const isLocked = isKeyLocked;

          return `
                      <label class="facet-checkbox-label" style="display: flex; align-items: center; gap: 10px; cursor: ${isLocked ? 'not-allowed' : 'pointer'}; font-size: 12px; color: ${isSelected ? '#fff' : '#aaa'}; transition: all 0.2s; text-transform: uppercase; letter-spacing: 0.05em; ${isLocked && !isSelectedBase ? 'opacity: 0.3;' : ''}">
                        <input type="checkbox" 
                          ${isSelected ? 'checked' : ''} 
                          ${isLocked ? 'disabled' : ''}
                          onclick="${isLocked ? 'event.preventDefault();' : `toggleVertexFilter('${key}', '${fv.value}')`}"
                          style="width: 16px; height: 16px; cursor: ${isLocked ? 'not-allowed' : 'pointer'}; accent-color: #fff; border: 1px solid #555;"
                        >
                        <span style="${isSelected ? 'font-weight: 800;' : 'font-weight: 500;'}">
                          ${fv.value} 
                          <span style="opacity: 0.3; font-size: 10px; margin-left: 4px;">(${fv.count})</span>
                          ${isSelectedBase ? '<span style="font-size: 10px; margin-left: 4px;" title="This filter is required for this page.">🔒</span>' : ''}
                        </span>
                      </label>
                    `;
        }).join("")}
                </div>
              </details>
            `;
      }).join("")}
          
          ${params.toString().includes("color=") || params.toString().includes("shape=") || params.toString().includes("size=") || params.toString().includes("size_bucket=") || params.toString().includes("style=") || params.toString().includes("material=") ? `
            <div style="margin-top: 20px;">
              <button 
                onclick="const q = new URLSearchParams(window.location.search).get('q'); window.location.href = q ? (window.location.pathname + '?q=' + encodeURIComponent(q)) : window.location.pathname;"
                style="width: 100%; padding: 12px; background: #fff; border: 1px solid #fff; color: #000; font-weight: 900; border-radius: 0; cursor: pointer; transition: all 0.2s; text-transform: uppercase; font-size: 10px; letter-spacing: 0.2em;"
              >
                Clear Filters
              </button>
            </div>
          ` : ""}
        </div>
      `;
    }

    function renderPage(items, apiData) {
      document.body.style.overflow = ''; // Reset scroll lock in case mobile filters were open
      const params = new URLSearchParams(window.location.search);
      const query = params.get("q")?.trim() || "";

      let fallbackBannerHtml = "";
      if (apiData && apiData.fallback_stage > 0) {
        const qLower = (query || "").toLowerCase();
        const colorsList = ['yellow', 'blue', 'red', 'green', 'grey', 'gray', 'black', 'white', 'beige', 'pink', 'orange', 'brown', 'purple', 'navy', 'ivory', 'cream', 'teal', 'gold', 'silver', 'charcoal', 'neutral', 'multi'];
        const shapesList = ['round', 'runner', 'oval', 'square', 'rectangle'];
        const stylesList = ['traditional', 'modern', 'vintage', 'boho', 'shag', 'geometric', 'abstract', 'distressed', 'classic', 'transitional', 'floral'];

        const foundColors = colorsList.filter(c => qLower.includes(c));
        const foundShapes = shapesList.filter(s => qLower.includes(s));
        const foundStyles = stylesList.filter(st => qLower.includes(st));

        let suggestionPills = "";
        const suggestedPillsList = [];

        foundColors.forEach(c => {
          const pillQuery = `${c} rugs`;
          if (pillQuery.toLowerCase() !== qLower) {
            suggestedPillsList.push({ label: `${c} rugs`, query: pillQuery });
          }
        });
        foundShapes.forEach(s => {
          const pillQuery = `${s} rugs`;
          if (pillQuery.toLowerCase() !== qLower) {
            suggestedPillsList.push({ label: `${s} rugs`, query: pillQuery });
          }
        });
        foundStyles.forEach(st => {
          const pillQuery = `${st} rugs`;
          if (pillQuery.toLowerCase() !== qLower) {
            suggestedPillsList.push({ label: `${st} rugs`, query: pillQuery });
          }
        });

        if (suggestedPillsList.length > 0) {
          const safeSeoMap = (typeof seoMap !== 'undefined') ? seoMap : (window.seoMap || {});
          suggestionPills = `
            <div style="margin-top: 16px; display: flex; gap: 8px; flex-wrap: wrap; align-items: center; border-top: 1px solid rgba(255, 255, 255, 0.06); padding-top: 14px;">
              <span style="font-size: 11px; font-weight: 700; color: #777; text-transform: uppercase; letter-spacing:0.08em; margin-right: 4px;">Explore separately:</span>
              ${suggestedPillsList.map(pill => {
                const qLower = pill.query.toLowerCase();
                const targetUrl = safeSeoMap[qLower] ? `/pages/${safeSeoMap[qLower]}` : `/search?q=${encodeURIComponent(pill.query)}`;
                return `
                <a href="${targetUrl}" 
                   style="display:inline-flex; align-items:center; padding: 6px 14px; background: rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.1); color: #e0e0e0; font-size: 11px; font-weight: 700; border-radius: 20px; text-decoration: none; text-transform: capitalize; transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);" 
                   onmouseover="this.style.background='#fff'; this.style.color='#000'; this.style.borderColor='#fff'; this.style.transform='translateY(-1px)';" 
                   onmouseout="this.style.background='rgba(255,255,255,0.05)'; this.style.color='#e0e0e0'; this.style.borderColor='rgba(255,255,255,0.1)'; this.style.transform='none';">
                  ${pill.label}
                </a>
              `; }).join('')}
            </div>
          `;
        }

        // Map raw developer stage descriptions to customer-friendly copy
        let friendlyReason = "Showing our closest matching items instead.";
        switch (Number(apiData.fallback_stage)) {
          case 1:
            friendlyReason = "We don't have that exact size in stock, but here are some close matches.";
            break;
          case 2:
            friendlyReason = "We couldn't find that specific brand, so we are showing matches across all our premium makers.";
            break;
          case 3:
            friendlyReason = "That specific size is currently unavailable, showing matches in other sizes with the same color and style.";
            break;
          case 4:
            friendlyReason = "That specific shape is currently unavailable, showing matches in other shapes with the same color and style.";
            break;
          case 5:
            friendlyReason = "We couldn't find matches in that exact color or style, showing alternative choices in the requested size.";
            break;
          case 6:
          case 7:
            friendlyReason = "We couldn't find matches for this exact combination, but here are some popular styles you might love.";
            break;
          default:
            friendlyReason = apiData.fallback_reason || "Showing our closest matching items instead.";
        }

        fallbackBannerHtml = `
          <div class="vertex-fallback-banner" style="background: rgba(255, 255, 255, 0.02); border: 1px solid rgba(255, 255, 255, 0.08); padding: 20px 24px; margin-bottom: 35px; border-radius: 8px; text-align: left; box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);">
            <div style="display: flex; gap: 10px; align-items: center; margin-bottom: 8px;">
              <span style="font-size: 16px; color: #ffa500; display: inline-flex; align-items: center; justify-content: center; line-height: 1;">💡</span>
              <h4 style="margin: 0; color: #fff; text-transform: uppercase; font-size: 12px; font-weight: 800; letter-spacing: 0.1em; line-height: 1.2;">No direct match found for "${query}"</h4>
            </div>
            <p style="margin: 0; font-size: 13px; color: #aaa; line-height: 1.6; font-weight: 400;">
              ${friendlyReason}
            </p>
            ${suggestionPills}
          </div>
        `;
      }

      const vertexRoot = document.getElementById("vertex-search-root");

      const getOptimizedImageUrl = (url, size = 600) => {
        if (!url) return "";
        let clean = url.toString().trim();
        if (clean.startsWith("//")) clean = "https:" + clean;

        if (clean.includes("storage.googleapis.com") || clean.includes("discovery-ai-v3-public")) {
          if (!clean.includes('/card/') && !clean.includes('/thumb/')) {
            try {
              const urlParts = clean.split('/');
              const filename = urlParts.pop();
              const newFilename = filename.replace(/\.(jpg|jpeg|png)$/i, '.webp');
              clean = urlParts.join('/') + '/card/' + newFilename;
            } catch (e) {
              clean = clean.replace(/\.(jpg|jpeg|png)$/i, '.webp');
            }
          }
          return clean;
        }

        if (window.CloudImageHandler && typeof window.CloudImageHandler.optimizeImageUrl === 'function') {
          return window.CloudImageHandler.optimizeImageUrl(clean);
        }

        if (clean.includes("cdn.shopify.com") && clean.includes("/products/")) {
          return clean.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|master|\d+x\d*)/g, "").replace(/\.(jpg|jpeg|png|gif|webp)/i, `_${size}x${size}.$1`);
        } else if (clean.includes("cdn.shopify.com") && clean.includes("/files/")) {
          return clean.replace(/_\d+x\d*(?=\.(jpg|jpeg|png|gif|webp))/i, "");
        }
        if (clean.includes("owimages.com") || (!clean.includes("cdn.shopify.com") && !clean.includes("storage.googleapis.com"))) {
          const stripped = clean.replace(/^https?:\/\//, "");
          return `https://wsrv.nl/?url=${encodeURIComponent(stripped)}&w=${size}&output=webp&q=80`;
        }
        return clean;
      };

      if (!items || items.length === 0) {
        const currentFilters = [];
        const filterKeys = ['shape', 'color', 'size_bucket', 'style', 'material'];
        filterKeys.forEach(key => {
          const val = params.get(key);
          if (val) currentFilters.push(`<span style="color:#fff;">${val}</span>`);
        });

        const sizeBucket = params.get('size_bucket');
        let suggestionHtml = "";
        if (sizeBucket) {
          const suggestions = {
            '5x8': '8x10 or 9x12',
            '8x10': '9x12 or 10x14',
            '2x3': '3x5 or 4x6',
            '3x5': '5x8 or 8x10',
            '9x12': '10x14 or 8x10'
          };
          const alt = suggestions[sizeBucket];
          if (alt) {
            suggestionHtml = `<p style="color:#fff; font-weight:700; margin-top:20px; font-size:13px; text-transform:uppercase; letter-spacing:0.1em;">Try searching for <span style="text-decoration:underline; cursor:pointer;" onclick="toggleVertexFilter('size_bucket', '${alt.split(' or ')[0]}')">${alt}</span> instead?</p>`;
          }
        }

        const filterDesc = currentFilters.length > 0 ? ` with ${currentFilters.join(' + ')}` : '';

        vertexRoot.innerHTML = `
          <div class="vertex-search-layout" style="display:block; text-align:center; padding: 100px 20px; color:#fff;">
            <div style="font-size: 64px; margin-bottom: 20px;">🔍</div>
            <h2 style="font-size: 24px; font-weight: 900; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 15px;">We couldn't find any rugs${filterDesc}</h2>
            <p style="color: #aaa; font-size: 14px; max-width: 500px; margin: 0 auto 30px; line-height: 1.6;">
              Our weavers are talented, but this specific combination is elusive! <br>
              Try clearing some filters or exploring a different size to find your perfect match.
            </p>
            ${suggestionHtml}
            <div style="margin-top:40px;">
              <button onclick="const cq = new URLSearchParams(window.location.search).get('q'); window.location.href = cq ? (window.location.pathname + '?q=' + encodeURIComponent(cq)) : window.location.pathname;" 
                style="padding: 15px 40px; background: #fff; color: #000; border: none; font-weight: 900; text-transform: uppercase; letter-spacing: 0.15em; cursor: pointer; font-size: 12px;">
                Reset Filters
              </button>
            </div>
          </div>
        `;
        return;
      }

      const cardsHtml = items.map(p => {
        let pdpUrl = (function (p) {
          const src = p.url || p.product_url || p.shopify_url || "";
          if (src.includes("/products/")) return "/products/" + src.split("/products/").pop().replace(/^owfam-/, '');
          let handle = p.shopify_handle || p.handle || (p.id ? p.id.toString().split("/").pop() : "");
          if (handle.startsWith("owfam-")) handle = handle.substring(6);
          return handle ? `/products/${handle}` : "#";
        })(p);

        if (pdpUrl !== "#" && window.vertexSearchContext && window.vertexSearchContext.attributionToken) {
          pdpUrl += (pdpUrl.includes('?') ? '&' : '?') + 'vtoken=' + window.vertexSearchContext.attributionToken;
        }

        let rawImageUrl = p.image_url || p.visualizer_image_url || p.image || "";
        const imagesArray = p.images || (rawImageUrl ? [{ uri: rawImageUrl }] : []);

        const isRoundRequested = window.location.pathname.includes('round-rugs') || 
                                 new URLSearchParams(window.location.search).get('q')?.toLowerCase().includes('round') || 
                                 new URLSearchParams(window.location.search).getAll('shape').some(s => s.toLowerCase() === 'round');

        if (isRoundRequested) {
           const roundImg = imagesArray.find(img => { const u = (img.uri||img.url||img.src||"").toLowerCase(); return u.includes('_rnd') || u.includes('_round') || u.includes('-round') || u.includes('round_'); });
           if (roundImg) {
              rawImageUrl = roundImg.uri || roundImg.url || roundImg.src;
           }
        }

        const imageUrl = getOptimizedImageUrl(rawImageUrl);
        const isExplicitSize = !!p.has_explicit_size_intent;
        const minPrice = p.min_price || p.price;
        const maxPrice = p.max_price || p.price;

        let priceHtml = '';
        if (isExplicitSize || !minPrice || minPrice === maxPrice) {
          priceHtml = `<span class="price" style="font-weight:900; color:#fff; font-size:15px; display:block; margin-top:2px; letter-spacing: 0.05em;">$${Number(p.price || minPrice).toLocaleString()}</span>`;
        } else {
          priceHtml = `<span class="price" style="font-weight:900; color:#fff; font-size:15px; display:block; margin-top:2px; letter-spacing: 0.05em;">$${Number(minPrice).toLocaleString()} - $${Number(maxPrice).toLocaleString()}</span>`;
        }

        let swatchesHtml = '';
        const variants = p.variants_info || [];
        if (!isExplicitSize && variants.length > 0) {
          // Optimization: On mobile, if there are 3+ sizes, hide the individual swatches
          // and show a single "X Sizes Available" button to preserve vertical space for the rug image.
          const isMobile = window.innerWidth < 750;
          const initialLimit = (isMobile && variants.length > 2) ? 0 : 5;
          const hasMore = variants.length > initialLimit;

          swatchesHtml = `
            <div class="size-swatches">
              ${variants.map((v, idx) => {
            const style = idx >= initialLimit ? 'display:none;' : '';
            const className = idx >= initialLimit ? 'swatch-hidden' : '';
            let vUrl = v.url || pdpUrl;
            if (vUrl && vUrl.includes("/products/")) {
              const parts = vUrl.split("/products/");
              vUrl = "/products/" + parts[parts.length - 1];
            }
            if (v.variant_id) {
              try {
                const urlObj = new URL(vUrl, window.location.origin);
                urlObj.searchParams.set("variant", v.variant_id);
                vUrl = urlObj.pathname + urlObj.search;
              } catch (e) {
                if (!vUrl.includes("variant=")) {
                  vUrl += (vUrl.includes("?") ? "&" : "?") + "variant=" + v.variant_id;
                }
              }
            }
            return `<a href="${vUrl}" class="${className}" onclick="event.stopPropagation();" style="${style}">${v.size}</a>`;
          }).join('')}
              ${hasMore ? `<span class="swatch-more" onclick="event.preventDefault(); event.stopPropagation(); this.parentElement.querySelectorAll('.swatch-hidden').forEach(el=>el.style.display='inline-block'); this.style.display='none';">${initialLimit === 0 ? `<span style="border-bottom:1px solid #666; padding-bottom:1px;">${variants.length} Sizes Available</span>` : `+${variants.length - initialLimit} more`}</span>` : ''}
            </div>
          `;
        }

        const displaySize = p.selected_size || p.size_bucket || p.size || "";
        const displayShape = (p.shape || "").toString().trim();
        const shapeLabel = displayShape ? displayShape[0].toUpperCase() + displayShape.slice(1) : "";

        const metaLineParts = [];
        if (p.brands) {
          const b = Array.isArray(p.brands) ? p.brands[0] : p.brands;
          if (b) metaLineParts.push(`<span style="color:#fff; font-weight:900;">${b}</span>`);
        }
        if (displaySize && isExplicitSize) metaLineParts.push(displaySize);
        if (shapeLabel) metaLineParts.push(shapeLabel);

        const pMat = p.material || p.materials || "";
        const displayMat = Array.isArray(pMat) ? pMat[0] : pMat;
        if (displayMat && displayMat.toLowerCase() !== 'n/a') metaLineParts.push(displayMat);

        const metaLineHtml = metaLineParts.length ? `<div class="card-information vertex-meta-line" style="font-size:10px; color:#aaa; margin:4px 0; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; line-height: 1.2;">${metaLineParts.join(' • ')}</div>` : '';

        const safeTitle = (p.title || "Untitled Rug").replace(/'/g, "\\'");
        const safeHandle = (p.shopify_handle || p.handle || "").replace(/'/g, "\\'");

        return `
          <li class="grid__item vertex-product-card-tracker" data-product-id="${p.id}" data-attribution-token="${window.getAttributionToken() || ''}">
            <div class="card-wrapper product-card-wrapper" onclick="window.trackVertexEvent('product_click', {product_ids: ['${p.id}'], attribution_token: this.parentElement.getAttribute('data-attribution-token')})">
              <div class="card card--standard">
                <div class="card__inner" style="position:relative;">
                  <favorites-button class="wishlist-btn wishlist-overlay" product-handle="${safeHandle}" product-title="${safeTitle}" product-price="${priceHtml.replace(/"/g, '&quot;')}" product-image="${imageUrl}" product-url="${pdpUrl}" style="position: absolute; top: 8px; right: 8px; z-index: 2; color: #666;"></favorites-button>
                  <a href="${pdpUrl}" class="full-unstyled-link">
                    <img class="vertex-product-image" src="${imageUrl}" alt="${p.title || ''}" loading="lazy" data-current-url="${rawImageUrl}" style="width:100%; aspect-ratio:1; object-fit:cover;" onerror="if(window.handleVertexImageError) window.handleVertexImageError(this, '${btoa(JSON.stringify(imagesArray))}', '${safeHandle}', '${safeTitle}')"/>
                  </a>
                </div>
                <div class="card__content" style="padding-top: 8px;">
                  <h3 class="card__heading h5 vertex-card-title" style="margin-bottom:0; font-weight: 900; text-transform: uppercase; letter-spacing: 0.05em; font-size: 12px; line-height: 1.3; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;">
                    <a href="${pdpUrl}" class="full-unstyled-link" style="text-decoration:none; color: #fff;">${p.title || "Untitled Rug"}</a>
                  </h3>
                  ${metaLineHtml}
                  <div class="card-information vertex-card-info" style="margin-top: 4px;">
                    ${priceHtml}
                    ${swatchesHtml ? `<div class="vertex-swatches-container" style="margin-top: 6px;">${swatchesHtml}</div>` : ''}
                  </div>
                </div>
              </div>
            </div>
          </li>
        `;
      }).join("");

      const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
      let pagination = totalPages > 1 ? `<div style="text-align:center;margin-top:40px; padding: 30px; border-top: 1px solid #333;"><button onclick="changeSearchAiPage(-1)" ${currentPage === 1 ? "disabled" : ""} style="padding: 12px 25px; cursor: pointer; background:transparent; color:#fff; border:1px solid #fff; text-transform: uppercase; font-weight: 900; font-size: 11px; letter-spacing: 0.1em; margin-right: 10px;">&larr; Prev</button><span style="margin:0 20px; font-weight: 900; color:#fff; font-size: 12px; text-transform: uppercase; letter-spacing: 0.1em;">${currentPage} / ${totalPages}</span><button onclick="changeSearchAiPage(1)" ${currentPage === totalPages ? "disabled" : ""} style="padding: 12px 25px; cursor: pointer; background:transparent; color:#fff; border:1px solid #fff; text-transform: uppercase; font-weight: 900; font-size: 11px; letter-spacing: 0.1em; margin-left: 10px;">Next &rarr;</button></div>` : "";

      vertexRoot.innerHTML = `
        <style>
          .vertex-search-root { color: #fff; }
          .vertex-search-layout { display: grid; grid-template-columns: 280px 1fr; gap: 60px; padding: 40px 0; max-width: 1600px; margin: 0 auto; position: relative; }
          .vertex-sidebar { position: sticky; top: 120px; align-self: start; z-index: 10; }
          .vertex-main-results { border-left: 1px solid #333; padding-left: 40px; }
          
          @media (max-width: 989px) {
            .vertex-search-layout { grid-template-columns: 1fr; padding: 0 15px; }
            .vertex-sidebar { 
              position: fixed; top: 0; left: 0; width: 100%; height: 100%; 
              z-index: 9999; padding: 30px; overflow-y: auto; background: #000;
              transform: translateX(-100%); transition: transform 0.4s cubic-bezier(0.16, 1, 0.3, 1);
            }
            .vertex-sidebar.active { transform: translateX(0); }
            .vertex-main-results { border-left: none; padding-left: 0; }
            .mobile-filter-bar { display: flex; justify-content: space-between; align-items: center; padding: 15px 0; margin-bottom: 20px; border-bottom: 1px solid #333; }
            .vertex-mobile-close { display: block; }
          }
          .size-swatches {
            display: flex;
            flex-wrap: wrap;
            gap: 6px;
            margin-top: 8px;
          }
          .size-swatches a {
            position: relative;
            z-index: 10;
            font-size: 10px;
            color: #ccc;
            border: 1px solid #444;
            padding: 4px 8px;
            border-radius: 4px;
            text-transform: uppercase;
            font-weight: 700;
            text-decoration: none;
            background: #111;
            transition: all 0.2s ease;
            display: inline-block;
          }
          .size-swatches a:hover {
            background: #fff;
            color: #000;
            border-color: #fff;
          }
          .swatch-more {
            position: relative;
            z-index: 10;
            font-size: 10px;
            color: #888;
            padding: 4px 0;
            font-weight: 700;
            cursor: pointer;
            text-transform: uppercase;
            margin-left: 4px;
            transition: color 0.2s ease;
            display: inline-block;
          }
          .swatch-more:hover {
            color: #fff;
          }
          @media (max-width: 749px) {
            .vertex-card-title { font-size: 10px !important; line-height: 1.2 !important; }
            .vertex-meta-line { font-size: 8px !important; margin: 2px 0 !important; letter-spacing: 0 !important; }
            .vertex-card-info { margin-top: 2px !important; }
            .vertex-card-info .price { font-size: 13px !important; margin-top: 1px !important; }
            .vertex-swatches-container { margin-top: 4px !important; }
            .size-swatches { gap: 3px !important; }
            .size-swatches a { padding: 2px 5px !important; font-size: 8px !important; }
            .swatch-more { font-size: 8px !important; }

            .vertex-results-heading {
              margin-bottom: 28px !important;
            }

            .vertex-results-title {
              font-size: 24px !important;
              line-height: 1.12 !important;
              letter-spacing: 0.08em !important;
            }

            .vertex-results-subtitle {
              font-size: 12px !important;
              line-height: 1.35 !important;
            }

          .vertex-main-results .product-grid {
            grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
            column-gap: 14px !important;
            row-gap: 34px !important;
          }

          .vertex-main-results .card__inner {
            height: 205px !important;
            aspect-ratio: auto !important;
            overflow: hidden !important;
            border-radius: 14px !important;
            background: #ffffff !important;
          }

          .vertex-main-results .card__inner a {
            display: flex !important;
            width: 100% !important;
            height: 100% !important;
            align-items: center !important;
            justify-content: center !important;
          }

          .vertex-main-results .vertex-product-image {
            width: 100% !important;
            height: 100% !important;
            aspect-ratio: auto !important;
            object-fit: contain !important;
            padding: 4px !important;
            transform: none !important;
            background: #ffffff !important;
          }
          }
          @media (min-width: 990px) {
            .mobile-filter-bar { display: none; }
            .vertex-mobile-close { display: none; }
          }
          .facet-accordion summary::-webkit-details-marker { display: none; }
          .facet-options::-webkit-scrollbar { width: 4px; }
          .facet-options::-webkit-scrollbar-thumb { background: #555; border-radius: 0; }

          .vertex-main-results h2 {
            color: #fff;
            letter-spacing: 0.08em;
            text-transform: uppercase;
            font-weight: 900;
          }

          .vertex-results-heading {
            margin-bottom: 34px;
          }

          .vertex-results-title {
            font-size: 22px !important;
            line-height: 1.18 !important;
            margin: 0 !important;
          }

          .vertex-results-subtitle {
            color: #aaa;
            margin-top: 10px;
            font-size: 13px;
            text-transform: uppercase;
            font-weight: 700;
            letter-spacing: 0.05em;
          }
        </style>

        <div class="vertex-search-layout">
          <aside class="vertex-sidebar">
            ${renderFilters(currentFacets)}
          </aside>

          <main class="vertex-main-results">
            <div class="mobile-filter-bar">
               <button onclick="toggleMobileFilters()" style="background: #fff; color: #000; border: none; padding: 10px 20px; font-weight: 900; text-transform: uppercase; letter-spacing: 0.1em; cursor: pointer; font-size: 11px;">Refine Results</button>
               <span style="font-size: 12px; font-weight: 700; color: #aaa; text-transform: uppercase; letter-spacing: 0.05em;">${totalItems} Items</span>
            </div>

            ${(window.vertexPageContext && window.vertexPageContext.mode === 'browse') ? '' : `
            <div class="vertex-results-heading">
              <h2 class="vertex-results-title">Search Results: ${query}</h2>
            </div>
            `}
            
            ${fallbackBannerHtml}
            
            <ul class="grid product-grid grid--2-col-tablet-down grid--3-col-desktop" style="justify-content: center;">
              ${cardsHtml}
            </ul>
            ${pagination}
          </main>
        </div>
        </div>
      `;

      setTimeout(() => {
        document.querySelectorAll('.vertex-product-card-tracker').forEach(el => impressionObserver.observe(el));
      }, 100);
    }

    performAiSearch();
  };

  initSearch();
});